import { render, staticRenderFns } from "./Tab1MedicalRecords.vue?vue&type=template&id=0a3e901c&scoped=true&"
import script from "./Tab1MedicalRecords.vue?vue&type=script&lang=js&"
export * from "./Tab1MedicalRecords.vue?vue&type=script&lang=js&"
import style0 from "./Tab1MedicalRecords.vue?vue&type=style&index=0&id=0a3e901c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e901c",
  null
  
)

export default component.exports